export const GET_OPERATIONS_MACHINE_MAP_REQUEST =
  "GET_OPERATIONS_MACHINE_MAP_REQUEST";
export const GET_OPERATIONS_MACHINE_MAP_SUCCESS =
  "GET_OPERATIONS_MACHINE_MAP_SUCCESS";
export const GET_OPERATIONS_MACHINE_MAP_FAILURE =
  "GET_OPERATIONS_MACHINE_MAP_FAILURE";

export const CREATE_OPERATIONS_MACHINE_MAP_REQUEST =
  "CREATE_OPERATIONS_MACHINE_MAP_REQUEST";
export const CREATE_OPERATIONS_MACHINE_MAP_SUCCESS =
  "CREATE_OPERATIONS_MACHINE_MAP_SUCCESS";
export const CREATE_OPERATIONS_MACHINE_MAP_FAILURE =
  "CREATE_OPERATIONS_MACHINE_MAP_FAILURE";

export const UPDATE_OPERATIONS_MACHINE_MAP_REQUEST =
  "UPDATE_OPERATIONS_MACHINE_MAP_REQUEST";
export const UPDATE_OPERATIONS_MACHINE_MAP_SUCCESS =
  "UPDATE_OPERATIONS_MACHINE_MAP_SUCCESS";
export const UPDATE_OPERATIONS_MACHINE_MAP_FAILURE =
  "UPDATE_OPERATIONS_MACHINE_MAP_FAILURE";

export const DELETE_OPERATIONS_MACHINE_MAP_REQUEST =
  "DELETE_OPERATIONS_MACHINE_MAP_REQUEST";
export const DELETE_OPERATIONS_MACHINE_MAP_SUCCESS =
  "DELETE_OPERATIONS_MACHINE_MAP_SUCCESS";
export const DELETE_OPERATIONS_MACHINE_MAP_FAILURE =
  "DELETE_OPERATIONS_MACHINE_MAP_FAILURE";

export const GET_LABELS_WITH_PAGINATION_REQUEST =
  "GET_LABELS_WITH_PAGINATION_REQUEST";
export const GET_LABELS_WITH_PAGINATION_SUCCESS =
  "GET_LABELS_WITH_PAGINATION_SUCCESS";
export const GET_LABELS_WITH_PAGINATION_FAILURE =
  "GET_LABELS_WITH_PAGINATION_FAILURE";
